import type { ReturnLossRow } from "@estelle/domain";

import type { Projection } from "@/modules/types";

/**
 * A `ReturnLossRow` flattened for `RETURN_LOSS_FIELDS`, from the row alone. The
 * photo is its count, which is what a CSV can say; the screen draws the picture.
 */
export function projectReturnLossRow(row: ReturnLossRow): Projection {
  return {
    receivedAt: row.receivedAt,
    orderNumber: row.orderNumber,
    outcome: row.outcome,
    item: row.item,
    sku: row.sku ?? "",
    quantity: row.quantity,
    reason: row.reason,
    photo:
      row.photoCount === 0
        ? ""
        : `${String(row.photoCount)} photo${row.photoCount === 1 ? "" : "s"}`,
    receivedBy: row.receivedByName ?? "",
  };
}
